import { RawTextInput } from '@festina-life/ui/forms'
import { useTranslate } from '@festina-life/ui/hooks'
import { type ChangeEvent, useCallback, useState } from 'react'

import { useFPlusScopeFilterValue } from '../../context/fPlusScopeFilterValueContext'

type FPlusScopeFunctionOrVariableFilterProps = {
  onChange: () => void
}

export const FPlusScopeFilter = ({
  onChange,
}: FPlusScopeFunctionOrVariableFilterProps) => {
  const [value, setValue] = useState<string>('')
  const translate = useTranslate()
  const { setFilterValue } = useFPlusScopeFilterValue()

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value
      setValue(value)

      const nextValue = value.trim()
      const sanitisedValue = nextValue.replace(/\s/g, '')

      setFilterValue(sanitisedValue)
      onChange()
    },
    [onChange, setFilterValue],
  )

  return (
    <RawTextInput
      onChange={handleChange}
      placeholder={translate('templateViewer.sidebar.scopePopover.filter')}
      value={value}
      className="m-2! max-w-[10em]"
    />
  )
}
